export async function handleLoginError(error, t) {
    const data = error?.response?.data || {};
    const errorCode = data.errorcode;
    const errorMessage = data.error;

    const errorCodeMap = {
        [-1]: "common.messages.errors.loginProvidedDoesnotExist",
        [-2]: "common.messages.errors.invalidLogin",
        [2]:  "common.messages.errors.twoFactorCodeExpired",
        [1]:  "common.messages.errors.invalidTwoFactorCode",
        [7]:  "common.messages.errors.unableToAccessTheSystemThroughAnUnregisteredIP",
    };

    if (errorCode in errorCodeMap) {
        return t(errorCodeMap[errorCode]);
    }

    const errorMessageMap = {
        "The new password has already been used previously.": "components.myProfile.changePassword.newPasswordAlreadyUsed",
        "Invalid authorization key.": "common.messages.errors.resetLinkExpired",
    };

    if (errorMessage && errorMessageMap[errorMessage]) {
        return t(errorMessageMap[errorMessage]);
    }

    return t("common.messages.errors.generic");
}

export async function handleError(error, t, name = null) {
    switch (error.status) {
        case 400:
            return t("common.messages.errors.400");
        case 401:
        case 403:
            return t("common.messages.errors.403");
        case 409:
            return t("common.messages.errors.409", {name: name});
        default:
            return t("common.messages.errors.generic");
    }
}
